<div class="close-btn-container">
  <button
    mat-icon-button
    color="primary"
    (click)="onCloseDialog()"
    onclick="this.blur()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="scroll-container">
    <div
      class="row"
      *ngIf="data.kcmState$ && data.kcmState$ | async as kcmState"
    >
      <div class="label">KCM</div>
      <mat-spinner *ngIf="kcmState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="kcmState.response && !kcmState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!kcmState.response && !kcmState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div class="row" *ngIf="data.crewState$ | async as crewState">
      <div class="label">Crew</div>
      <mat-spinner *ngIf="crewState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="crewState.response && !crewState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!crewState.response && !crewState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.crewLocationState$ | async as crewLocationState"
    >
      <div class="label">Crew Location</div>
      <mat-spinner
        *ngIf="crewLocationState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="crewLocationState.response && !crewLocationState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!crewLocationState.response && !crewLocationState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <!-- Release and weather are bundled together because weather relies on release. To make the UI more
       graceful, show loading indicator for weather if release is still loading.  -->
    <ng-container
      *ngIf="{
        weatherState: data.weatherState$ | async
      } as vm"
    >
      <!-- <div class="row"> -->
      <!--   <div class="label">Release</div> -->
      <!--   <mat-spinner *ngIf="vm.releaseState?.isLoading" diameter="24"></mat-spinner> -->
      <!--   <mat-icon *ngIf="vm.releaseState?.response && !vm.releaseState?.isLoading" -->
      <!--     class="success-color">task_alt</mat-icon> -->
      <!--   <mat-icon *ngIf="!vm.releaseState?.response && !vm.releaseState?.isLoading" -->
      <!--     class="caution-color">cancel</mat-icon> -->
      <!-- </div> -->
      <div class="row">
        <div class="label">Weather</div>
        <mat-spinner
          *ngIf="vm.weatherState?.isLoading"
          diameter="24"
        ></mat-spinner>
        <mat-icon
          *ngIf="vm.weatherState?.response && !vm.weatherState?.isLoading"
          class="success-color"
          >task_alt</mat-icon
        >
        <mat-icon
          *ngIf="!vm.weatherState?.response && !vm.weatherState?.isLoading"
          class="caution-color"
          >cancel</mat-icon
        >
      </div>
    </ng-container>
    <div class="row" *ngIf="data.armedPaxState$ | async as armedPaxState">
      <div class="label">Armed Pax</div>
      <mat-spinner *ngIf="armedPaxState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="armedPaxState.response && !armedPaxState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!armedPaxState.response && !armedPaxState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.inboundCrewListState$ | async as inboundCrewListState"
    >
      <div class="label">Inbound Crew</div>
      <mat-spinner
        *ngIf="inboundCrewListState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="inboundCrewListState.response && !inboundCrewListState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !inboundCrewListState.response && !inboundCrewListState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.inboundFlightStatusState$ | async as inboundFlightStatusState"
    >
      <div class="label">Inbound Flight</div>
      <mat-spinner
        *ngIf="inboundFlightStatusState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="
          inboundFlightStatusState.response &&
          !inboundFlightStatusState.isLoading
        "
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !inboundFlightStatusState.response &&
          !inboundFlightStatusState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.aircraftDetailsState$ | async as aircraftDetailsState"
    >
      <div class="label">Aircraft Details</div>
      <mat-spinner
        *ngIf="aircraftDetailsState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="aircraftDetailsState.response && !aircraftDetailsState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !aircraftDetailsState.response && !aircraftDetailsState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div class="row" *ngIf="data.melsState$ | async as melsState">
      <div class="label">Aircraft MELs</div>
      <mat-spinner *ngIf="melsState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="melsState.response && !melsState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!melsState.response && !melsState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.aircraftRoutingState$ | async as aircraftRoutingState"
    >
      <div class="label">Aircraft Routing</div>
      <mat-spinner
        *ngIf="aircraftRoutingState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="aircraftRoutingState.response && !aircraftRoutingState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !aircraftRoutingState.response && !aircraftRoutingState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div class="row" *ngIf="data.paxLoadState$ | async as paxLoadState">
      <div class="label">Load</div>
      <mat-spinner *ngIf="paxLoadState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="paxLoadState.response && !paxLoadState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!paxLoadState.response && !paxLoadState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div class="row" *ngIf="data.standbyListState$ | async as standbyListState">
      <div class="label">Standby List</div>
      <mat-spinner
        *ngIf="standbyListState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="standbyListState.response && !standbyListState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!standbyListState.response && !standbyListState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="{
        jumpseaters: data.jumpseaters$ | async,
        isLoading: data.jumpseatersIsLoading$ | async
      } as js"
    >
      <div class="label">Jumpseaters</div>
      <mat-spinner *ngIf="js.isLoading" diameter="24"></mat-spinner>
      <mat-icon *ngIf="!js.isLoading" class="success-color">task_alt</mat-icon>
    </div>
    <div
      class="row"
      *ngIf="data.hotelState$ && data.hotelState$ | async as hotelState"
    >
      <div class="label">Hotel</div>
      <mat-spinner *ngIf="hotelState.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="hotelState.response && !hotelState.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!hotelState.response && !hotelState.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="
        data.depFieldReport$ && data.depFieldReport$ | async as depFieldReport
      "
    >
      <div class="label">Dep Field Report</div>
      <mat-spinner *ngIf="depFieldReport.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="depFieldReport.response && !depFieldReport.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!depFieldReport.response && !depFieldReport.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="
        data.arrFieldReport$ && data.arrFieldReport$ | async as arrFieldReport
      "
    >
      <div class="label">Arr Field Report</div>
      <mat-spinner *ngIf="arrFieldReport.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="arrFieldReport.response && !arrFieldReport.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!arrFieldReport.response && !arrFieldReport.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="
        data.depStationInfoState$ && data.depStationInfoState$
          | async as depStationInfo
      "
    >
      <div class="label">Dep Station Info</div>
      <mat-spinner *ngIf="depStationInfo.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="depStationInfo.response && !depStationInfo.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!depStationInfo.response && !depStationInfo.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="
        data.arrStationInfoState$ && data.arrStationInfoState$
          | async as arrStationInfo
      "
    >
      <div class="label">Arr Station Info</div>
      <mat-spinner *ngIf="arrStationInfo.isLoading" diameter="24"></mat-spinner>
      <mat-icon
        *ngIf="arrStationInfo.response && !arrStationInfo.isLoading"
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="!arrStationInfo.response && !arrStationInfo.isLoading"
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.inboundConnectionsState$ | async as inboundConnectionsState"
    >
      <div class="label">Inbound Pax Connections</div>
      <mat-spinner
        *ngIf="inboundConnectionsState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="
          inboundConnectionsState.response && !inboundConnectionsState.isLoading
        "
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !inboundConnectionsState.response &&
          !inboundConnectionsState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <div
      class="row"
      *ngIf="data.outboundConnectionsState$ | async as outboundConnectionsState"
    >
      <div class="label">Outbound Pax Connections</div>
      <mat-spinner
        *ngIf="outboundConnectionsState.isLoading"
        diameter="24"
      ></mat-spinner>
      <mat-icon
        *ngIf="
          outboundConnectionsState.response &&
          !outboundConnectionsState.isLoading
        "
        class="success-color"
        >task_alt</mat-icon
      >
      <mat-icon
        *ngIf="
          !outboundConnectionsState.response &&
          !outboundConnectionsState.isLoading
        "
        class="caution-color"
        >cancel</mat-icon
      >
    </div>
    <mat-divider inline="true"></mat-divider>
    <div class="failed-note">
      <mat-icon class="caution-color">cancel</mat-icon>
      <span class="opacity-6 text-xs"
        >indicates not available or failed to load.</span
      >
    </div>
    <div class="text-xs opacity-6">Saved data will be available offline.</div>
    <div class="text-xs opacity-6">
      <i>Note:</i> Closing this dialog while an item is still loading will
      cancel that download.
    </div>
  </div>
</mat-dialog-content>
